// extracted by mini-css-extract-plugin
export default {"container":"Slider1_container__Z+nTg","swiperslide":"Slider1_swiperslide__prwIR"};